module.exports = __webpack_public_path__ + "img/logo_white.95c25d43.png";